import { useState, useEffect } from "react";
import OrderHeader from "../components/order/OrderHeader";
import BookPanel from "../components/order/BookPanel";
import OrderPanel from "../components/order/OrderForm/OrderPanel";

export default function OrderDecolonizingMission() {
  const [qty, setQty] = useState(1);
  const [country, setCountry] = useState(null);
  const [fulfilment, setFulfilment] = useState(null);
  const [collection, setCollection] = useState(null);
  const [deliveryLocation, setDeliveryLocation] = useState(null);

  const [isMobile, setIsMobile] = useState(
    window.innerWidth < 768
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () =>
      window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <OrderHeader />

      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile
            ? "1fr"
            : "340px 1fr 200px",
          minHeight: "100vh",
          width: "100%",
        }}
      >
        <BookPanel />

        <OrderPanel
          qty={qty}
          setQty={setQty}
          country={country}
          setCountry={setCountry}
          fulfilment={fulfilment}
          setFulfilment={setFulfilment}
          collection={collection}
          setCollection={setCollection}
          deliveryLocation={deliveryLocation}
          setDeliveryLocation={setDeliveryLocation}
        />

        {!isMobile && <div />}
      </div>
    </>
  );
}